export default {
    UNDER_CONSTRUCTION: false
}